(ns practitest.frontend.components2.feedback
  (:require [ajax.core :as ajax]
            [practitest.frontend.common-entities.metadata :as metadata]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(def ^:private extra-db-entities
  "Entity types not in entities-metadata (not grid-backed) that still need feedback support."
  {:assistant-message "AssistantMessage"})

(defn- ->db-entity [entity-type]
  (or (get-in metadata/entities-metadata [entity-type :db-entity])
      (get extra-db-entities entity-type)))


(re-frame/reg-event-fx
  ::load-feedback
  (fn [{db :db} [_ feature entity-type entity-id local-state]]
    (let [project-id (subs/get-current-project-id db)]
      (swap! local-state assoc :loading? true)
      {:http-xhrio
       {:method          :get
        :uri             (broutes/get-url "feedbacks#for_feature"
                                          {:project_id project-id}
                                          {:feature feature
                                           :entity_id entity-id
                                           :entity_type (->db-entity entity-type)})
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::load-feedback-success local-state]
        :on-failure      [::load-feedback-failure local-state]}})))

(re-frame/reg-event-fx
  ::load-feedback-failure
  (fn [{} [_ local-state]]
    (swap! local-state assoc :loading? false)
    {}))

(re-frame/reg-event-fx
  ::load-feedback-success
  (fn [{} [_ local-state response]]
    (swap! local-state assoc
           :loading? false
           :data response)
    {}))

(re-frame/reg-event-fx
  ::send-feedback!
  (fn [{db :db} [_ feature entity-type entity-id rating local-state]]
    (let [project-id (subs/get-current-project-id db)]
      (swap! local-state assoc :saving? true)
      {:http-xhrio
       {:method          :post
        :uri             (broutes/get-url "feedbacks#create"
                                          {:project_id project-id})
        :params          {:feature     feature
                          :entity_type (->db-entity entity-type)
                          :entity_id   entity-id
                          :rating rating}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::send-feedback-success local-state]
        :on-failure      [::send-feedback-failure local-state]}})))

(re-frame/reg-event-fx
  ::send-feedback-failure
  (fn [{} [_ local-state]]
    (swap! local-state assoc :saving? false)
    {}))

(re-frame/reg-event-fx
  ::send-feedback-success
  (fn [{} [_ local-state response]]
    (swap! local-state assoc
           :saving? false
           :data response)
    {}))

(defn feedback-component
  "Universal user feedback component"
  [{:keys [class
           feature
           entity-type
           entity-id
           mixpanel-up
           mixpanel-down] :as props}]
  (let [local-state (reagent/atom {})]
    (reagent/create-class
      {:component-did-mount (fn [this]
                              (let [{:keys [feature
                                            entity-type
                                            entity-id]
                                     :as props} (reagent/props this)]
                                (re-frame/dispatch [::load-feedback feature entity-type entity-id local-state])))
       :reagent-render      (fn [{:keys [class
                                         feature
                                         entity-type
                                         entity-id
                                         mixpanel-up
                                         mixpanel-down] :as props}]
                              (let [sending-feedback? (:saving? @local-state)
                                    loading? (:loading? @local-state)
                                    data (:data @local-state)
                                    rating (:rating data)
                                    thumbs-down? (neg? rating)
                                    thumbs-up? (pos? rating)]
                                [:div.feedback-buttons {:class class}
                                 [buttons/icon-button
                                  {:icon      (if thumbs-up?
                                                [icons/mux-thumbs-up-filled]
                                                [icons/mux-thumbs-up])
                                   :class     (dom/classes-pairs-v :active thumbs-up?
                                                                   :thumbs-button true)
                                   :mixpanel  mixpanel-up
                                   :disabled? (or sending-feedback?
                                                  loading?)
                                   :on-click  (fn [e]
                                                (re-frame/dispatch [::send-feedback! feature entity-type entity-id 1 local-state]))}]
                                 [buttons/icon-button
                                  {:icon      (if thumbs-down?
                                                [icons/mux-thumbs-down-filled]
                                                [icons/mux-thumbs-down])
                                   :mixpanel  mixpanel-down
                                   :class     (dom/classes-pairs-v :active thumbs-down?
                                                                   :thumbs-button true)
                                   :disabled? (or sending-feedback?
                                                  loading?)
                                   :on-click  (fn [e]
                                                (re-frame/dispatch [::send-feedback! feature entity-type entity-id -1 local-state]))}]]))})))
